import type { ReactNode } from 'react'

type SmartEvidenceRequestBannerLayoutProps = {
  title: string
  inviteRecipientModal: ReactNode
  description: ReactNode
  recipientsButton: ReactNode
  secondaryAction?: ReactNode
  primaryAction?: ReactNode
}

export const SmartEvidenceRequestBannerLayout = ({
  title,
  inviteRecipientModal,
  description,
  recipientsButton,
  secondaryAction,
  primaryAction,
}: SmartEvidenceRequestBannerLayoutProps) => {
  const hasActions = secondaryAction != null || primaryAction != null

  return (
    <div className='flex flex-col rounded border border-main-border-default bg-main-background-card px-4 py-3 shadow-sm'>
      {inviteRecipientModal}
      <div className='flex items-center justify-between gap-2'>
        <div className='flex items-center gap-2'>
          <div className='text-main-foreground-primary text-heading-xsmall'>{title}</div>
          <div className='text-main-foreground-tertiary text-body-default'>{description}</div>
        </div>
        {hasActions && (
          <div className='flex items-center gap-4'>
            {secondaryAction}
            {primaryAction}
          </div>
        )}
      </div>

      <div className='flex items-center gap-6'>{recipientsButton}</div>
    </div>
  )
}
